<template>
<div class="home-container">

        <section class="w-full hero-section">



<Particles
                id="tsparticles"

                :options="config"
        />
















            <div class="component-container z-10">
                <transition type="animation" enter-active-class="animate__animated animate__fadeInLeft" appear>   
                    <h2 class="aar-heading text-white col-start-2 col-end-13"> {{ $t('heroTitle') }}</h2>
                </transition>

                <transition type="animation" enter-active-class="animate__animated animate__fadeInLeft animate__delay-02s " appear>   
                    <h4 class="aar-heading__thin text-white col-start-2 col-end-13">{{ $t('heroMessage') }}</h4>
                </transition>
            </div>
        </section>


        <section id="experiences" class="component-container col-start-1 col-end-13">
            <div class="aar-homepage-left">
                <model-viewer 
                    auto-rotate camera-controls
                    data-js-focus-visible
                    loading="eager"
                    shadow-intensity="1"
                    stage-light-intensity="3" environment-intensity="2"
                    camera-orbit="0deg 65deg 25m"
                    ar
                    :poster="require(`../assets/images/plane-engine.png`)"
                    src="https://www.accadigital.com/models/plane-engine/plane-engine.gltf"
                    class="aar-homepage-left__mv">
                </model-viewer>
            </div>

            <div class="aar-homepage-right">
                <h3 class="mb-10"> {{ $t('experiencesTitle') }} </h3>
                <p class="aar-text"> {{ $t('experiencesText') }} </p>
                <p class="aar-text"> {{ $t('experiencesText2') }} </p>
                <a href="https://ar.accadigital.com" class="is-button button-primary mobile-scale"> {{ $t('experiencesButton') }}  </a>
            </div>
        </section>

        <section id="services" class="is-container col-start-1 col-end-13">
            <div class="component-container py-32 items-baseline gap-y-16">
                <ac-icon-div class="col-start-1 col-end-4" :title="$t('title1')" :text="$t('text1')" icon="web.png"></ac-icon-div>
                <ac-icon-div class="col-start-4 col-end-7" :title="$t('title2')" :text="$t('text2')" icon="app.png"></ac-icon-div>
                <ac-icon-div class="col-start-7 col-end-10" :title="$t('title3')" :text="$t('text3')" icon="ar.png"></ac-icon-div>
                <ac-icon-div class="col-start-10 col-end-13" :title="$t('title4')" :text="$t('text4')" icon="vr.png"></ac-icon-div>

                <ac-icon-div class="col-start-1 col-end-4" :title="$t('title5')" :text="$t('text5')" icon="optimization.png"></ac-icon-div>
                <ac-icon-div class="col-start-4 col-end-7" :title="$t('title6')" :text="$t('text6')" icon="automation.png"></ac-icon-div>
                <ac-icon-div class="col-start-7 col-end-10" :title="$t('title7')" :text="$t('text7')" icon="docs.png"></ac-icon-div>
                <ac-icon-div class="col-start-10 col-end-13" :title="$t('title8')" :text="$t('text8')" icon="advisory.png"></ac-icon-div>
            </div>
        </section>
            

        <section id="contact" ref="contact">
            <div class="component-container py-32 justify-center">
                <div class="flex flex-col items-center justify-center col-start-3 col-end-11">
                     <h3 class="text-center mb-10">{{ $t('contactTitle') }}</h3>
                     <p class="aar-text text-center mb-16">{{ $t('contactText') }} </p>
                    <a href="mailto:info@accadigital.com" class="is-button button-primary mobile-scale"> {{ $t('contactButton') }}  </a>
                </div>
               
            </div>
        </section>

</div>

</template>


<script>
  import { ModelViewer } from "@google/model-viewer";
  import AcIconDiv from "./reusable/AcIconDiv.vue"

export default {
  name: 'HomePage',
  data(){
      return {
      publicPath: process.env.BASE_URL,
      config: {
        "fullScreen": false,
        "particles": {
            "number": {
            "value": 237,
            "density": {
                "enable": true,
                "value_area": 1578.2952832645453
            }
            },
            "color": {
            "value": "#939393"
            },
            "shape": {
            "type": "circle",
            "stroke": {
                "width": 0,
                "color": "#000000"
            },
            "polygon": {
                "nb_sides": 5
            },
            "image": {
                "src": "img/github.svg",
                "width": 100,
                "height": 100
            }
            },
            "opacity": {
            "value": 0.5,
            "random": false,
            "anim": {
                "enable": false,
                "speed": 1,
                "opacity_min": 0.1,
                "sync": false
            }
            },
            "size": {
            "value": 2,
            "random": true,
            "anim": {
                "enable": false,
                "speed": 5,
                "size_min": 0.1,
                "sync": false
            }
            },
            "line_linked": {
            "enable": true,
            "distance": 150,
            "color": "#939393",
            "opacity": 0.4,
            "width": 1
            },
            "move": {
            "enable": true,
            "speed": 6,
            "direction": "none",
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
                "enable": false,
                "rotateX": 600,
                "rotateY": 1200
            }
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {
            "onhover": {
                "enable": true,
                "mode": "grab"
            },
            "onclick": {
                "enable": true,
                "mode": "push"
            },
            "resize": true
            },
            "modes": {
            "grab": {
                "distance": 300,
                "line_linked": {
                "opacity": 1
                }
            },
            "bubble": {
                "distance": 400,
                "size": 40,
                "duration": 2,
                "opacity": 8,
                "speed": 3
            },
            "repulse": {
                "distance": 200,
                "duration": 0.4
            },
            "push": {
                "particles_nb": 4
            },
            "remove": {
                "particles_nb": 2
            }
            }
        },
        "detectRetina": true
            }

    }
  },   

  components: {
      ModelViewer: ModelViewer,
      AcIconDiv: AcIconDiv,
  }
}
</script>


<style scoped lang="scss">
  @import "../styles/core/variables.scss";
  @import "../styles/global/helpers.scss";
  @import "../styles/global/components.scss";

    #services{
        background-color: $color-bg-dark;
    }

    #tsparticles{
        position: absolute;
        z-index: 0;
        width: 100%;
        height: 101vh; // same as hero section container.
    }

    canvas.tsparticles-canvas-el{
        position: absolute !important;
    }

    .component-container{
        overflow: hidden;
    }

  .aar-homepage-left{
      grid-column: 2 / 7;
  }

  .aar-homepage-right {
      grid-column: 7 / 12;
      align-self: center;

  }

model-viewer {
    height: 70rem;
    }


  // Mobile responsive

  @media screen and (max-width: $mobile-small){

        #tsparticles{
            display: none;
        }

    .component-container{
        display: flex;
        flex-direction: column;
        overflow-y: none;
    }

.aar-homepage-left__img, .ar-homepage-left__mv{
        max-width: 50rem;
        margin-bottom: -10rem;
    }

    model-viewer{
        max-height: 35rem;
    }

    .aar-homepage-right{
        width: 100%;
    }

}


</style>
